export interface KnowledgeArticleArabicText {
  title: string;
  summary?: string;
  content: string;
}

export const KNOWLEDGE_BASE_ARTICLES_AR: Record<string, KnowledgeArticleArabicText> = {
  dashboard: {
    title: 'لوحة التحكم',
    summary: 'نظرة عامة على مؤشرات ESG والرسوم وتخطيط اللوحة.',
    content:
      'تعرض لوحة التحكم لمحة سريعة عن الأداء البيئي لمنظمتك. تعكس بطاقات مؤشرات الأداء والرسوم البيانات المحفوظة في مصدر البيانات والوحدات الأخرى.\n\nاختر دليلاً أدناه للتعليمات خطوة بخطوة.',
  },
  'dashboard-overview': {
    title: 'نظرة عامة على لوحة التحكم',
    summary: 'جولة إرشادية كاملة للوحة التحكم (نفس جولة الترحيب).',
    content:
      'استخدم «الذهاب إلى لوحة التحكم» لجولة إرشادية بنفس خطوات نافذة الترحيب:\n\n1. تبويب شهري — اختر شهراً، افتح تخصيص اللوحة، عيّن حدود KPI، ثم راجع بطاقات ESG والرسوم.\n\n2. تبويب الفروع — راجع مقاييس الفروع وافتح مقارنة الفروع.\n\n3. تبويب تجنّب الكربون — حدّد نطاق التاريخ والمسار، ثم راجع النتائج.\n\nلتركيز أعمق على منطقة واحدة، افتح حدود KPI أو الفروع/المقارنة أو تجنّب الكربون أدناه.\n\nنصيحة: تتحدّث أرقام اللوحة عند حفظ بيانات جديدة في مصدر البيانات.',
  },
  'dashboard-widget-customization': {
    title: 'تخصيص لوحة التحكم',
    content:
      '1. في لوحة التحكم، انقر «تخصيص لوحة التحكم» (أعلى اليمين).\n\n2. تخصّص النافذة التبويب المفتوح — الشهري، النظرة العامة، النطاقات، الفروع، أو تجنّب الكربون.\n\n3. حدّد أو ألغِ تحديد العناصر التي تظهر في ذلك التبويب.\n\n4. انقر «حفظ التغييرات». يُحفظ اختيارك في جلسة المتصفح الحالية.\n\nنصيحة: إذا ظهرت رسالة «لم يتم اختيار عناصر»، افتح التخصيص وأضف المقاييس التي تحتاجها.',
  },
  'dashboard-kpi-limits': {
    title: 'حدود KPI',
    summary: 'عيّن الأهداف وراجع حدود KPI المفعّلة في العرض الشهري.',
    content:
      'استخدم «الذهاب إلى حدود KPI» لجولة قصيرة:\n\n1. في التبويب الشهري، افتح حدود KPI.\n\n2. أضف أو عدّل حداً — اختر المقياس والقيمة المستهدفة وما إذا كان مفعّلاً.\n\n3. راجع قائمة الحدود؛ تظهر مؤشرات KPI المفعّلة على بطاقات اللوحة.\n\nنصيحة: تساعد حدود KPI على تتبع التقدّم مقابل الأهداف الشهرية للمنظمة المحددة.',
  },
  'dashboard-branches-compare': {
    title: 'الفروع والمقارنة',
    summary: 'راجع مقاييس كل فرع وقارن الفروع جنباً إلى جنب.',
    content:
      'استخدم «الذهاب إلى الفروع» لجولة قصيرة:\n\n1. افتح تبويب الفروع في لوحة التحكم.\n\n2. راجع جدول الفروع وبطاقات المؤشرات لكل موقع.\n\n3. انقر «مقارنة الفروع» لفتح مربع المقارنة واختيار الفروع.\n\nنصيحة: تعمل المقارنة أفضل عندما يتوفر بيانات لفرعين على الأقل في الشهر المحدد.',
  },
  'dashboard-carbon-avoidance': {
    title: 'تبويب تجنّب الكربون',
    summary: 'حدّد فترة الكربون والمسار ثم راجع نتائج التجنّب.',
    content:
      'استخدم «الذهاب إلى تجنّب الكربون» لجولة قصيرة:\n\n1. افتح تبويب تجنّب الكربون في لوحة التحكم.\n\n2. حدّد تاريخ البداية والنهاية لفترة التقرير.\n\n3. اختر فلتر مسار النفايات إن أردت عرضاً مركّزاً.\n\n4. راجع إجماليات ورسوم تجنّب الكربون.\n\nملاحظة: يستخدم تقرير PDF لتجنّب الكربون نفس الفترة (وليس منتقي شهر التقارير).',
  },
  'esg-reports': {
    title: 'استخراج التقارير',
    summary: 'أنشئ وحمّل تقارير ESG بصيغة PDF.',
    content:
      'تُنشئ تقارير ESG ملفات PDF للمنظمة المحددة في الشريط العلوي.\n\nأكمل إدخالات مصدر البيانات للشهر قبل إنشاء التقرير.\n\nاستخدم «تخصيص التقرير» لاختيار الأقسام التي تظهر في كل PDF، ثم اختر تقريراً أدناه للتنزيل، أو افتح تعريفات المقاييس لمعرفة معنى كل مقياس وكيفية البحث في الكتالوج.',
  },
  'report-general-esg': {
    title: 'تقرير الأداء البيئي العام',
    content:
      'التعريف — تقرير PDF شهري يعرض نظرة شاملة على الأداء البيئي للمنظمة.\nالمحتوى — النفايات المعالجة، استهلاك المرافق وتكاليفها، مؤشرات جودة التشغيل، وساعات التدريب في ملف واحد.\nالفترة — منتقي الشهر في صفحة التقارير.\n\nماذا يتضمن:\n• ملخص تنفيذي — إجماليات النفايات والمرافق والتدريب\n• النفايات — التحويل، إعادة التدوير، التكوين، وتقارير الامتلاء\n• المرافق — المياه والكهرباء والزيت والغاز بالريال\n• المراقبة والتدريب — مؤشرات الجودة وساعات التدريب\n\nنصيحة: القيم الصفرية أو المفقودة غالباً تعني عدم حفظ بيانات مصدر البيانات لذلك الشهر.',
  },
  'report-waste-circularity': {
    title: 'تقرير النفايات والتدوير',
    content:
      'التعريف — تقرير PDF يركّز على النفايات ويربطها بمواضيع الإفصاح GRI 306.\nالمحتوى — كمية النفايات المعالجة والمحوّلة والمُعاد تدويرها، مع تفصيل الفروع وملاحظات التغطية. ليس إقرار GRI رسمي أو ضمان خارجي.\nالفترة — منتقي الشهر في صفحة التقارير.\n\nماذا يتضمن:\n• ملخص تنفيذي — النفايات المعالجة والمحوّلة والمُعاد تدويرها\n• تدفقات النفايات — الوارد، التكوين، والتحويل/إعادة التدوير\n• الفروع — أداء كل فرع عند توفر البيانات\n• خريطة GRI 306 — علاقة المقاييس بمواضيع الإفصاح\n\nنصيحة: القيم الصفرية أو المفقودة غالباً تعني عدم حفظ بيانات مصدر البيانات لذلك الشهر.',
  },
  'report-carbon-avoidance': {
    title: 'تقرير تجنّب الكربون',
    content:
      'التعريف — تقرير PDF يقدّر كمية الكربون المتجنّب (tCO₂e) من عمليات تحويل النفايات المكتملة.\nالمحتوى — إجمالي التجنّب، التفصيل حسب نوع النفايات، وتفاصيل الحساب للمراجعة.\nالفترة — لوحة التحكم → تجنّب الكربون (وليس منتقي الشهر في التقارير).\n\nماذا يتضمن:\n• ملخص تنفيذي — إجمالي المتجنّب، الكتلة، وعدد العمليات\n• التيارات — حصة كل نوع من إجمالي التجنّب\n• ملحق التدقيق — حالة العمليات وعوامل الانبعاث\n\nملاحظة: تقرير تجنّب الكربون يستخدم فترة لوحة التحكم، وليس منتقي الشهر.',
  },
  'report-metric-definitions': {
    title: 'تعريفات المقاييس',
    summary: 'تصفّح وابحث في تعريفات المقاييس المستخدمة في تقارير ESG.',
    content:
      'استخدم «الذهاب إلى تعريفات المقاييس» لجولة قصيرة:\n\n1. افتح تبويب تعريفات المقاييس في تقارير ESG.\n\n2. استخدم البحث لتصفية المقاييس بالاسم أو الكلمة المفتاحية.\n\n3. افتح بطاقة مقياس لقراءة تعريفه ووحدته ومكان ظهوره في التقارير.\n\nنصيحة: تشرح تعريفات المقاييس الأرقام خلف ملفات PDF — استخدمها عندما يبدو رقم التقرير غير مألوف.',
  },
  'data-source': {
    title: 'مصدر البيانات (المرافق)',
    content:
      'يُستخدم مصدر البيانات لتسجيل استهلاك المرافق الشهري (المياه، الكهرباء، الزيت، الغاز) لكل فرع. تغذّي البيانات المحفوظة لوحة التحكم وتقارير ESG.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'data-source-intro': {
    title: 'نظرة عامة على مصدر البيانات',
    content:
      '1. من القائمة الجانبية، افتح «مصدر البيانات».\n\n2. اختر فرعاً (موقع تجميع) من قائمة الفروع.\n\n3. حدّد شهر التقرير من منتقي التقويم.\n\n4. استخدم تبويبات المرافق — المياه، الكهرباء، الزيت، الغاز — لإدخال الاستهلاك والتكلفة.\n\n5. انتقل إلى «إثباتات المرافق» لإرفاق المستندات الداعمة، أو «الإعدادات» لضبط خيارات الفرع.',
  },
  'utility-data-entry': {
    title: 'إدخال وحفظ بيانات المرافق',
    content:
      '1. اذهب إلى «مصدر البيانات» واختر فرعاً وشهر التقرير.\n\n2. افتح تبويب المرافق المطلوب (المياه، الكهرباء، الزيت، أو الغاز).\n\n3. أدخل قيم الاستهلاك والمبالغ بالريال حيث ينطبق ذلك.\n\n4. كرّر لكل نوع مرافق مطلوب لذلك الفرع.\n\n5. انقر «حفظ» وانتظر رسالة التأكيد قبل تغيير الفرع أو الشهر.\n\nملاحظة مهمة: تُفقد التغييرات غير المحفوظة عند تغيير الفرع أو الشهر أو مغادرة الصفحة.\n\nنصيحة: أدخل البيانات بانتظام كل شهر لضمان اتساق اتجاهات اللوحة وتقارير PDF.',
  },
  'utility-proofs': {
    title: 'إثباتات المرافق',
    content:
      '1. في «مصدر البيانات»، اختر الفرع وشهر التقرير.\n\n2. افتح تبويب «إثباتات المرافق».\n\n3. ارفع الفواتير أو قراءات العدادات التي تدعم أرقام الاستهلاك.\n\n4. راجع الملفات المرفوعة في القائمة واحذف الإثباتات القديمة عند الحاجة.\n\nأفضل ممارسة: احرص على توافق الإثباتات مع نفس شهر إدخالات الاستهلاك لجاهزية التدقيق.',
  },
  'data-source-settings': {
    title: 'إعدادات مصدر البيانات',
    content:
      '1. اذهب إلى «مصدر البيانات» واختر فرعاً.\n\n2. افتح تبويب «الإعدادات».\n\n3. عدّل خيارات الفرع مثل تفضيلات القياس أو القيم الافتراضية في نماذج المرافق.\n\n4. احفظ أي تغييرات قبل مغادرة التبويب.\n\nنصيحة: اضبط الإعدادات مرة واحدة لكل فرع جديد، ثم ركّز على الإدخال الشهري.',
  },
  'employee-training': {
    title: 'تدريب الموظفين',
    content:
      'يعرض تدريب الموظفين ملخصاً لنشاط التدريب في منظمتك. سجّل الجلسات، وافتح صفحات تفاصيل الموظفين، ونظّم التدريب حسب الفئة.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'employee-training-overview': {
    title: 'نظرة عامة على التدريب',
    content:
      '1. من القائمة الجانبية، افتح «تدريب الموظفين».\n\n2. راجع جدول الملخص الذي يعرض الموظفين وساعات التدريب وتاريخ آخر جلسة.\n\n3. استخدم مربع البحث للعثور على موظف محدد.\n\n4. انقر على رؤوس الأعمدة للفرز حسب الاسم أو الساعات أو التاريخ.\n\n5. انقر على صف أو أيقونة العرض لفتح صفحة تفاصيل تدريب الموظف.',
  },
  'record-training-session': {
    title: 'تسجيل جلسة تدريب',
    content:
      '1. في صفحة تدريب الموظفين، انقر «تسجيل تدريب» (أعلى اليمين).\n\n2. اختر الموظف وفئة التدريب وتاريخ الجلسة.\n\n3. أدخل ساعات التدريب وأي ملاحظات مطلوبة.\n\n4. أرسل النموذج. يتحدّث جدول الملخص بالإجماليات الجديدة.\n\nنصيحة: سجّل الجلسات فور انتهائها للحفاظ على دقة تقارير الامتثال.',
  },
  'employee-training-detail': {
    title: 'تفاصيل تدريب الموظف',
    content:
      '1. من جدول نظرة التدريب، افتح صفحة تفاصيل الموظف.\n\n2. راجع سجل الجلسات والفئات والساعات التراكمية.\n\n3. سجّل جلسات إضافية من هذه الصفحة حيثما كان ذلك متاحاً.\n\n4. استخدم زر الرجوع للعودة إلى ملخص المنظمة.\n\nتُعدّ صفحة التفاصيل المصدر الوحيد لمراجعة سجل التدريب الكامل لموظف واحد.',
  },
  'training-categories': {
    title: 'فئات التدريب',
    content:
      'تصنّف فئات التدريب الجلسات (مثل السلامة، الوعي البيئي، أو المهارات التشغيلية).\n\n• اختر الفئة الصحيحة عند تسجيل جلسة — تؤثر على التقارير والتصفية.\n• تظهر الفئات في نماذج الجلسات وصفحات تفاصيل الموظف.\n• التصنيف المتسق يساعد الإدارة على مراجعة الامتثال حسب الموضوع.\n\nإذا لم تكن متأكداً من الفئة، اختر الأقرب وأضف التفاصيل في ملاحظات الجلسة.',
  },
  'health-safety': {
    title: 'الصحة والسلامة',
    content:
      'تُسجّل وحدة الصحة والسلامة بيانات السلامة التشغيلية الأسبوعية لكل فرع. املأ جدول التقرير واحفظ الإدخالات وراجع المصطلحات المعيارية.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'hse-weekly-report': {
    title: 'أكمل تقرير السلامة الأسبوعي',
    content:
      '1. من القائمة الجانبية، افتح «الصحة والسلامة».\n\n2. اختر فرعاً من قائمة الفروع.\n\n3. حدّد أسبوع التقرير من منتقي الأسبوع.\n\n4. املأ كل صف في الجدول — أدخل العدد الأسبوعي والملاحظات الاختيارية. راجع «مصطلحات السلامة» للتعريفات.\n\n5. انقر «حفظ» لتخزين التقرير.\n\nتؤكد رسالة النجاح حفظ التقرير الأسبوعي.\n\nنصيحة: أكمل التقارير في نهاية كل أسبوع بينما التفاصيل لا تزال حديثة.',
  },
  'hse-terms': {
    title: 'مصطلحات السلامة',
    content:
      'مرجع — مصطلحات شائعة في تقارير السلامة:\n\n• حادث — حدث غير مخطط له يؤدي أو قد يؤدي إلى إصابة أو ضرر\n• حادث وشيك — حدث كان يمكن أن يسبب ضرراً لكنه لم يحدث\n• ملاحظة — نتيجة جولة سلامة أو قائمة فحص موثّقة\n• إجراء تصحيحي — خطوات لمعالجة خطر مُحدّد\n• إصابة بوقت ضائع — إصابة تسببت في غياب عن العمل\n\nاستخدم تعريفات متسقة عبر الفروع لضمان موثوقية اتجاهات السلامة المجمّعة.',
  },
  notifications: {
    title: 'الإشعارات',
    content:
      'تُبقيك الإشعارات على اطلاع بنشاط المنصة. افتح أيقونة الجرس في الشريط العلوي لمراجعة العناصر غير المقروءة.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'notification-bell': {
    title: 'جرس الإشعارات',
    content:
      '1. انقر على أيقونة الجرس في الشريط العلوي.\n\n2. يعرض الشارة عدد الإشعارات غير المقروءة.\n\n3. مرّر في القائمة لقراءة التنبيهات الأخيرة لمنظمتك.\n\n4. انقر خارج القائمة أو اضغط Escape لإغلاقها.\n\nتُقيَد الإشعارات بالمنظمة المحدّدة حالياً في الشريط العلوي.',
  },
  'mark-notifications-read': {
    title: 'تعليم الإشعارات كمقروءة',
    content:
      '1. افتح قائمة جرس الإشعارات.\n\n2. انقر على إشعار واحد لتعليمه كمقروء — يختفي من قائمة غير المقروء.\n\n3. استخدم «تعليم الكل كمقروء» لمسح جميع الإشعارات غير المقروءة دفعة واحدة.\n\n4. يتحدّث عداد الشارة فوراً بعد التعليم.\n\nنصيحة: تعليم الإشعارات كمقروءة لا يحذفها من سجل النظام في الخادم.',
  },
  'account-settings': {
    title: "الحساب والتفضيلات",
    summary: "غيّر لغة الواجهة والسمة وأدر حسابك.",
    content:
      "افتح قائمة الحساب من ملفك الشخصي في أسفل الشريط الجانبي لتغيير لغة الواجهة، والتبديل بين الوضع الفاتح والداكن، وتسجيل الخروج. يعرض ملفك اسم المستخدم والمنظمة النشطة.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.",
  },
  'change-language': {
    title: "تغيير اللغة",
    summary: "بدّل لغة المنصة بين اللغات المدعومة.",
    content:
      "1. انقر على ملفك الشخصي في أسفل الشريط الجانبي لفتح قائمة الحساب.\n\n2. انقر «اللغات».\n\n3. اختر لغتك من القائمة: الإنجليزية، العربية، الأردية، الهندية، البنغالية، السنهالية، أو النيبالية.\n\n4. تتحدّث الواجهة فوراً، ويُحفظ اختيارك في المرة التالية.\n\nملاحظة: العربية والأردية تبدّلان التخطيط تلقائياً من اليمين إلى اليسار. الواجهة ومحتوى المساعدة متوفران بجميع اللغات المدعومة.",
  },
  'appearance-theme': {
    title: "الوضع الفاتح والداكن",
    summary: "بدّل بين المظهر الفاتح والداكن.",
    content:
      "1. انقر على ملفك الشخصي في أسفل الشريط الجانبي لفتح قائمة الحساب.\n\n2. استخدم مفتاح «الوضع الداكن» للتبديل بين السمتين.\n\n3. يُحفظ تفضيلك تلقائياً ويُطبَّق في كل زيارة.",
  },
};
